import { render, staticRenderFns } from "./InvoiceWrapper.vue?vue&type=template&id=a6aca6d0&"
import script from "./InvoiceWrapper.vue?vue&type=script&lang=js&"
export * from "./InvoiceWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports